import type { PipelineStage } from "./dealData";

// Next action and days in stage of a deal (task 1.8, D-037). Days are
// counted on Rome dates, as the follow-up job does.
const ROME_DAY = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome" });
const DAY_MS = 24 * 60 * 60 * 1000;

// YYYY-MM-DD in Rome
export const romeDay = (value: string | Date) =>
  ROME_DAY.format(new Date(value));

export const isOpenStage = (stage?: PipelineStage) =>
  !!stage && !stage.is_won && !stage.is_lost;

// The database refuses an open deal without a next action
export const needsNextAction = (
  deal: { next_action_at?: string | null },
  stage?: PipelineStage,
) => isOpenStage(stage) && !deal.next_action_at;

export const isOverdue = (nextActionAt: string, now: Date = new Date()) =>
  romeDay(nextActionAt) < romeDay(now);

export const daysInStage = (enteredAt: string, now: Date = new Date()) =>
  Math.round(
    (Date.parse(romeDay(now)) - Date.parse(romeDay(enteredAt))) / DAY_MS,
  );

export const isPastLimit = (
  enteredAt: string,
  stage?: PipelineStage,
  now: Date = new Date(),
) =>
  !!stage?.max_days &&
  isOpenStage(stage) &&
  daysInStage(enteredAt, now) >= stage.max_days;

// A date input value (YYYY-MM-DD) for today in Rome
export const todayInput = (now: Date = new Date()) => romeDay(now);
